import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import classes from './SiteNavBDesktopLevelA.module.scss';

const SiteNavBDesktopLevelA = (props) => {
  const {
    items = [],
  } = props;

  return (
    <div className={classes.container}>
      <div className={classes.wrapper}>
        <div className={classes.globalNavList}>
          {items.map(({
            href,
            target,
            heading,
          }, index) => (
            href &&
              <Link
                className={classes.globalNavLink}
                href={href}
                target={target}
                key={`desktop-global-link-${index}`}
                dangerouslySetInnerHTML={{ __html: heading }}
              />
          ))}
        </div>
      </div>
    </div>
  );
};

const TItem = PropTypes.shape({
  heading: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
});

SiteNavBDesktopLevelA.propTypes = {
  items: PropTypes.arrayOf(TItem),
};

export default SiteNavBDesktopLevelA;
